import { ChangeDetectorRef, Component, EventEmitter, Query, ViewChild, Input, Output, ViewChildren, ContentChildren, Directive, ElementRef, QueryList, OnInit, trigger, state, animate, style, transition, keyframes, group } from '@angular/core';
import { HashLocationStrategy, Location, LocationStrategy } from '@angular/common';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Http, Response, Headers } from '@angular/http';

import { CookieService } from 'ngx-cookie';
import { animateOpen } from './create/newuser.animations';
import { featuresBox, featureslist } from '../store/animations';
import { overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, darkness, paymenticon, forumError, accountpayment, fundButtons, terms, paypalpayment, giftwindow, giftcontainer, giftpayment, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewOptionList, viewDetails, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewSwitch, viewInfoItem, viewInfoText, taglineSpan, taglineField, forum, popover, gamecopies, newsWindow, cryptocurrency, dualfactorsection, qrcode }  from './animations.overlay';
import { menuitem, profile, features, community,items, edit, claims, security, people, character, chat, accountControls, profileSearch }  from './animations.panels';

import { UserCliamsComponent } from './user-claims/user.claims.component';
import { AppUpload } from '../app.upload';
import { UserService } from '../services/user.service';
import { StoreService } from '../services/store.service';
import { SocialService } from '../services/social.service';
import { environment } from '../environment';

// Products
import { Item } from '../models/item';
import { Claim } from '../models/claim';
import { Order } from '../models/order';
import { Product } from '../models/product';
import { Country } from '../models/country';
import { Currency } from '../models/currency';

// Users
import { Account, Machine } from '../models/account';
import { Background } from '../models/background';
import { Friend } from '../models/friend';
import { Post } from '../models/post';
import { News } from '../models/news';
import { Group } from '../models/group';
import { Conversation, Message } from '../models/message';
import { Notification } from '../models/notification';
import { Method } from '../models/method';

//
declare var paypal: any;

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  providers: [
  	UserService,
  	StoreService,
  	SocialService,
  	AppUpload,
  	Location,
  	{provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  inputs: [ 'giftproduct', 'giftitem', 'sharelisting' ],
  outputs: [ 'reloadClaims' ],
  animations: [
  		darkness,
  		overlay,
  		paymentmethod,
  		accountControls,
  		paymenterror,
  		menuitem,
  		character,
  		chat,
  		features,
  		profile,
  		people,
  		paymenticon,
  		community,
  		edit,
  		claims,
  		security,
  		items,
  		fundButtons,
  		details,
  		share,
  		payment,
  		paymentresult,
  		accountpayment,
  		terms,
  		paypalpayment,
  		giftwindow,
  		giftcontainer,
  		giftpayment,
  		giftresult,
  		agreement,
  		gifticon,
  		editProfile,
  		editAddress,
  		editPassword,
  		editEmail,
  		editUsername,
  		forumError,
  		viewOptionBlock,
  		viewOptionList,
  		viewDetails,
  		viewFade,
  		viewOwner,
  		viewIcons,
  		viewIconicText,
  		viewBeta,
  		viewOption,
  		viewSwitch,
  		viewDesc,
  		viewInfo,
  		viewInfoItem,
  		viewInfoText,
  		taglineSpan,
  		taglineField,
  		forum,
  		popover,
  		featuresBox,
  		gamecopies,
  		newsWindow,
  		featureslist,
  		cryptocurrency,
  		animateOpen,
  		dualfactorsection,
  		profileSearch,
  		qrcode
  	]
})
export class UserComponent implements OnInit {

	/* Element Watchers */
	@ViewChild('fileInput') fileInput:ElementRef;
	@ViewChild('profileEditor') profileEditor:ElementRef;
	@ViewChildren('claimListing') product:QueryList<Product>;
	@ViewChild('username') username;
	@ViewChild('password') password;
	@ViewChild('email') email;
	@ViewChild('tagline') tagline;
	@ViewChild('formusername') formusername;

	@Input() giftingitem: Item;
	@Input() giftingproduct: Product;
	@Input() sharelisting: Product;

	@Output() reloadClaims: EventEmitter<any> = new EventEmitter();

	/* Header Tokens */
	public token: any;
	header: any;
	title: string;
	subtitle: string;
	headerHeight: any;
	headerAlign: any;
	chatEnabled: boolean;

	/* Models */
	searchResultsProduct: Product;
	searchResultsAccount: Account;
	searchResultsItem: Item;

	notification: Notification;
	defaultCurrency: Currency;
	backgrounds: Background;
	messages: Conversation;
	currencies: Currency;
	countries: Country;
	currency: Currency;
	giftConfirm: Product;
	products: Product;
	accounts: Account;
	machines: Machine;
	invited: Account;
	methods: Method;
	claims: Claim;
	groups: Group;
	order: Order;

	productsCount: any;
	claimscount: any;
	session: any;

	/* States */
	view = 'items';
	viewMode = 'list';
	viewPanel = 'desc';

	selectedCoin = 'bitcoin';
	environment = environment;
	coinAddress: string;
	currencyOpen = -1;
	numberOfMachines: number;
	ownprofile: boolean;
	dualFactorStatus: boolean;
	dualFactorQR: any;
	dualFactorKey: any;

	error: number;
	image: any;
	requests: any;
	orderPage: any;
	oAuthtimer: any;
	height: number;
	popopen: any;
	now: any;
	bg: any;
	bgpreview: any;
	searching: boolean;
	bgY = 0;

	/* Payment States */
	paypalCheckout: any;
	hosted = true;
	paymentState = '';
	errorCode = 0;
	errorMsg = '';

	/* User Vars */
	isAdmin = false;
	usererr = false;
	loading = false;
	usingOAuth = false;
	hasProducts = false;
	confirmpackage = false;
	editingBackground = false;
	savingAccount = false;
	loggedIn = false;
	fundButtons = true;
	updatingTagline = false;
	uploadProgress = 0;
	socialEnabled = false;
	claimReset = false;

	profileImage = '';
	editing = [];
	birthdate: any;
	addWhatCrypto = 0;

	itemscount = 0;

	/* OAuth Services */
	showSteamWarning: boolean;
	authServices = [];
	background = [
		'/assets/img/concept',
		'',
		'',
	];
		/* Models */

	profile = new Profile();
	oringinalprofile: any;
	credit = new CreditCard('', null, null, '', 1, false);
	gift = new Gift('', false);
	addAmount = new Amount(20);
	search = new Search(null);
	social = new Social(null);

	crypto = 0;
	selectedCrypto = null;
	cryptoProgress = 100;
	cryptoAddress: string;
	cryptoCurrencies: any;
	cryptoSelector = new Crypto();
	paymentDetails = new PaymentDetails();
	giftorder: Order;
	showFixture = 'false';
	fixture = 'in';
	totalClaims = 0;
	countryCode = 'US';

	/**  Get Steam OAuth provider **/
	get steamProvider(){
		return this.authServices
			.find( provider => provider.name === 'steam' )
	}


	/**	 Check whether user has a "Beta" access	**/
	get hasBetaAccess() : boolean {

		let claimedItems: number[] = this.accounts[0]['claimed_items'];
		if(claimedItems instanceof Array)
			for (let i = 0; i < claimedItems.length; i++)
				if(claimedItems[i] === 23)
					return true

		return false;
	}

  	constructor(private user: UserService,
  				private http: Http,
        		private cdRef: ChangeDetectorRef,
				private store: StoreService,
				private soc: SocialService,
				private sanitizer: DomSanitizer,
				private router: Router,
				private route: ActivatedRoute,
				private files: AppUpload,
				private cookie: CookieService
    ){
  		// User Environment Variables
			this.token = this.cookie.get('id');
			this.now = new Date();
			this.now.setMinutes(this.now.getMinutes() + 3000);
			let base = environment.baseUrl;

			// Enable Discord
			this.chatEnabled = false;

			// OAuth Services
			this.authServices = [
				{ id: 'steam_id', name: 'steam', icon:'fa fa-steam', link: null, enabled: 'has_steam' },
				{ id: 'facebook_id', name: 'facebook', icon:'fa fa-facebook-f', link: null, enabled: 'has_facebook' },
				// { id: 'live_id', name: 'live', icon: 'fa fa-windows', link: null, enabled: 'has_live' },
				// { id: 'discord_id', name: 'discord', icon: 'fa fa-discord', link: null, enabled: 'has_discord' },
			];

			// Cryto
			this.cryptoCurrencies = [
				{ id: 'bitcoin', name: 'Bitcoin', icon: 'fa fa-btc', enabled: 1 },
				{ id: 'litecoin', name: 'Litecoin', icon: 'fa fa-', enabled: 1 },
				{ id: 'dash', name: 'Dash Coin', icon: 'fa fa-', enabled: 1 },
			];

			// Parse hadtag (#) fragments of the URL to view corresponding user component
			router.events.subscribe(event => {
				if (event instanceof NavigationEnd) {
					const tree = router.parseUrl(router.url);
					if (tree.fragment) {
						const element = document.querySelector("#" + tree.fragment);
						// this.view = element;
					}
				}
	    	});

    }


   claimGameKey(){
   	this.user.claimGameKey().subscribe( r => this.authorize() )
   }

	/**	Callback function. Gets triggered if st  **/
	linkSteamProfile(){
		this.toggleOauth( this.steamProvider );
		window.open( this.steamProvider.link, '_blank').focus();
	}


    dosearch() {
	    this.user.search(this.search.term)
	      .subscribe(results => {
	        this.searchResultsItem = results[0];
	        this.searchResultsProduct = results[1];
	        this.searchResultsAccount = results[2];
	    });

		this.searching = true;
		if ( !this.search.term )
			this.searching = false;
    }

	openCurrency(y) {
		this.currencyOpen = (this.currencyOpen >= 0) ? -1 : y;
	}

	changeCurrency(currency) {
		this.currency = currency;
		this.store.changeCurrency(currency);
	}


    cachedMachines() {
		Promise.resolve( this.user.userMachines() ).then( (result) => {
			if ( result ) {
				this.machines = result;
				// this.user.countUserMachines().subscribe( (count) => {
				// 	this.numberOfMachines = count;
				// });
			}
		}).catch(function (err) { });
    }

    removeMachine( machineIdentifier ) {
		this.user.remoteLogout( machineIdentifier ).subscribe( (removal) => {
			this.numberOfMachines = removal.count;
			this.cachedMachines();
		});
    }


	doShare(service) {

		let url = this.environment.baseUrl+'/product/'+this.sharelisting.id;

		// Meta details for sharing
		let title = 'Identity RPG - '+this.sharelisting.title+' - '+this.sharelisting.description;

		switch (service) {
			case "facebook":
				var fbbase = 'https://www.facebook.com/sharer.php?u=';
				var fbs = fbbase + url + '&t=' + title;
				this.openWindow('265', '640', 'Share Identity on Facebook', fbs);
			break;
			case "twitter":
				var twbase = 'https://twitter.com/share?url=';
				var tws = twbase + url + '&text=' + title;
				this.openWindow('289', '624', 'Tweet about Identity', tws);
			break;
			case "google":
				var tmbase = 'https://plus.google.com/share?url='+url+'&name="Identity RPG - '+this.sharelisting.title+'"';
				this.openWindow('590', '400', 'Share Identity on Google Plus', tmbase);
			break;
			case "tumblr":
				var tmbase = 'https://plus.google.com/share?url='+url+'&name=Identity RPG - '+this.sharelisting.title+'&description='+this.sharelisting.description;
				this.openWindow('289', '624', 'Share Identity on Tumblr', tmbase);
			break;
			case "email":
				window.location.href = "mailto:address@gmail.com";
			break;
			default:

			break;
		}

	}


	openWindow(windowHeight, windowWidth, windowName, windowUri) {

		var centerWidth = (window.screen.width / 2) - windowWidth;
		var centerHeight = (window.screen.height / 2) - windowHeight;

		let newWindow = window.open(windowUri, windowName, 'resizable=0,width=' + windowWidth +
			',height=' + windowHeight +
			',left=' + centerWidth +
			',top=' + centerHeight);

		newWindow.focus();
		return newWindow.name;
	}

	shareItem(product:Product):void {
		// Open the gift widget
		this.showFixture = 'true';
		// Assign the listing clicked on
		this.sharelisting = product;
		this.fixture = '8';
	}


	giftProduct(product:Product):void {
 		// Open the gift widget
		this.showFixture = 'true';
		// Assign the listing clicked on
		this.confirmpackage = false;
		this.giftingitem = null;
		this.giftingproduct = product;
		this.fixture = '6';
	}

	giftItem(item:Item):void {
 		// Open the gift widget
		this.showFixture = 'true';
		// Assign the listing clicked on
		this.confirmpackage = false;
		this.giftingproduct = null;
		this.giftingitem = item;
		this.fixture = '6';
	}

	overlay(method) {
		this.resetPurhcase();

		// Open the funds widget
		this.showFixture = 'true';
		// Assign the listing clicked on

		this.credit.terms = false;
		this.errorCode = 0;

		if (method == 'gc') {
			this.fixture = '1';
			this.paymentState = method;
		} else if (method == 'paypal-hosted') {
			this.fixture = '5';
			this.paymentState = method;
		} else if (method == 'crypto') {
			this.fixture = '11';
			this.paymentState = method;
			this.newAddress();
		} else if (method == 'forum') {
			this.fixture = '13';
		} else if (method == 'dualfactor') {
			this.fixture = '12';
		}
	}

	resetPurhcase() {
		this.errorCode = 0;
		this.errorMsg = '';
		this.paypalCheckout = null;
	}

	changeViewMode(v) {
		this.viewMode = v;
		this.cookie.put('view', v, { expires: this.now });
		if ( this.viewMode == 'list') {
			this.viewPanel = 'both'
		} else { // block
			this.viewPanel = 'desc'
		}
	}

	sendGift() {

		// Is the client ready to release the gifts
		if ( this.gift.release === false ) {

			this.errorCode = 300;
			this.errorMsg = 'Please agree to release game items.';

		} if ( !this.gift.username ) {

			this.errorCode = 300;
			this.errorMsg = 'Please enter a username or email.';

		} else if ( this.gift.release == true ) {

			let id = this.giftingitem ? this.giftingitem.id : this.giftingproduct.id;
			let type = this.giftingitem ? 'items' : 'products';


			// Send a request to gift the listing to the username in the model
			Promise.resolve(this.store.sendGift(this.gift.username, id, type)).then((gifts) => {

				this.giftorder = gifts;
				this.errorCode = this.giftorder[0].code;

				if(this.giftorder[0].code != 200) {

					if( this.giftorder[0].err == 300 ) {
						this.confirmpackage = true;
						console.log( this.giftorder[0] );
					} else {
						this.errorMsg = this.giftorder[0].err;
					}

				} else if (this.errorCode == 200) {
					this.fixture = '7';
					this.errorCode = 200;
					this.errorMsg = 'GIFT SENT';
					this.gift.release = false;
					this.reloadClaims.next(true);
					this.claimReset = ( this.claimReset == true ) ? false : true;
					setTimeout (() => { this.fetchUserInfo(); this.errorCode = 0; }, 7000);
				}

			}).catch(function (err) {
				//
			});

		}
		// setTimeout (() => { this.errorCode = 0; }, 8000);
	}




	purchase() {

		if ( this.credit.terms === false ) {

			this.errorCode = 300;
			this.errorMsg = 'Please agree to the terms of service.';

		} else if ( this.credit.terms == true ) {

			this.errorCode = 100;
			this.errorMsg = 'Sending payment...';
			this.loading = true;

			this.paymentDetails.totalAmount = this.addAmount.amount*100;
			this.paymentDetails.currency = this.currency.symbol;
			this.paymentDetails.countryCode = this.countryCode;
			this.paymentDetails.isRecurring = false;
			this.paymentDetails.locale = "en_US";

			Promise.resolve( this.store.paymentRequest( this.credit, this.paymentDetails ) ).then( (paymentProduct) => {

				Promise.resolve( this.store.encryptData( this.credit, paymentProduct ) ).then( ( encryptedNumbers ) => {

					Promise.resolve( this.store.addFunds( this.addAmount.amount, this.paymentState, encryptedNumbers ) ).then( (order) => {

						// Handle the server return
						this.order = order;
						this.loading = false;
						this.errorCode = this.order[0].code;

						if(this.errorCode != 200) {
							// Assign the error code to the frontend
							this.errorMsg = this.order[0].err;
						} else if (this.errorCode == 200) {
							// A payment was successfully made
							this.errorMsg = 'Payment Complete';
							this.showFixture = 'true';
							this.fixture = '2';
							setTimeout (() => { this.errorCode = 0; this.errorMsg = ''; }, 5000);
							this.store.clearCart();
							this.authorize();
						}


					}).catch(function (err) {

						// The backend was not reached
						this.errorCode = 500;
						this.errorMsg = 'Error sending payment.';

					});

				});
			});
		}

		// Reset the error result after a time on screen
		setTimeout (() => { this.errorCode = 0; this.errorMsg = ''; }, 10000);
	}


	getPaymentProducts() {
		// Request data on valid payment methods for this account.
		Promise.resolve( this.store.getPaymentMethods() ).then((methods) => {
			this.methods = methods;
		});
	}


	// Generate a new hosted checkout URL
	paypalHostedCheckout() {
		if ( this.credit.terms === false ) {

			this.paypalCheckout = null;
			this.errorCode = 300;
			this.errorMsg = 'Please agree to the terms of service.';

		} else if ( this.credit.terms == true ) {
			this.paypalCheckout = null;
			Promise.resolve( this.store.paypalHostedCheckout(this.addAmount.amount) ).then((data) => {
				this.paypalCheckout = data;
			});
		}
	}

	checkHostedPayPal() {
		if ( this.credit.terms === false ) {

			this.errorCode = 300;
			this.errorMsg = 'Please agree to the terms of service.';

		} else if ( this.credit.terms == true ) {
			this.errorCode = 100;
			this.errorMsg = 'Authorizing with PayPal...';
			let paypalPurchase = setInterval( () => {
				Promise.resolve( this.store.checkPayPalHosted() ).then((order) => {
					// Handle the server return
					this.loading = false;
					this.order = order;
					this.errorCode = this.order[0].code;

					if(this.errorCode != 200) {
						// Assign the error code to the frontend
						this.errorMsg = this.order[0].err;
					} else if (this.errorCode == 200) {
						this.showFixture = 'true';
						// A payment was successfully made
						this.errorMsg = 'Payment Complete';
						this.fixture = '2';
						this.authorize();
						clearInterval(paypalPurchase);
					}

				}).catch(function (err) {
					// The backend was not reached
				});

			}, 5000);

			// setTimeout( function() { clearInterval(paypalPurchase); }, 80000);
		}
	}


	// Show / hide the terms of service in the payment modal
	showTerms() { this.orderPage = this.fixture; this.fixture = '4'; }
	backToOrder() { this.fixture = this.orderPage; }


	updateProfile(event) {
		let result: any;

		this.files.getObserver().subscribe(progress => {
			this.uploadProgress = progress;
		});

        try {
        	this.files.upload( `${this.environment.baseUrl}/api/profileimage/`, event.srcElement.files, this.token ).then(data => {
            	this.profileImage = data.image;
            	this.accounts[0].image = data.image;
            });
		} catch (error) {
			//
		}

	}


	uploadBackground(event) {
		let result: any;

		this.files.getObserver().subscribe(progress => {
			this.uploadProgress = progress;
		});

        try {
        	this.files.upload( `${this.environment.baseUrl}/api/updateuserbackground/`, event.srcElement.files, this.token ).then(data => {
            	this.background = data.image;
            	this.accounts[0].background = data.image;
            });
		} catch (error) {
			//
		}

	}


	getBackgorund(event) {
    	Promise.resolve( this.user.getBackgrounds(this.profile.background) ).then((data) => {
			this.header = this.sanitizer.bypassSecurityTrustStyle( 'url("'+data.url+'") data.position' );
		});
	}


	getBackgorunds() {
    	Promise.resolve( this.user.getBackgrounds() ).then((data) => {
    		this.backgrounds = data;
		});
	}


	authorize() {
		// Authorize a user
		this.user.authorizeUser().subscribe((user) =>  {

			if ( user ) {
				this.accounts = user;
				this.title = this.accounts[0].username;
				this.subtitle = this.accounts[0].tagline;
				this.birthdate = this.accounts[0].birthdate;
				this.socialEnabled = this.accounts[0].social;
				this.bg = this.accounts[0].background != '' ? this.accounts[0].background : '/assets/img/concept/TownSquare.jpg';
				this.header = this.sanitizer.bypassSecurityTrustStyle( 'url("'+this.bg+'")' );
				this.getAccount(this.accounts[0].username);
				this.isAdmin = ( user[0].role == "admin" ) ? true : false;
				if ( user ) this.loggedIn = true;
				this.profile = this.accounts[0];
			} else {
				this.router.navigate(['/login']);
			}

		    // Fixing bug with a blank space at a place of a "Claim The Key" button.
		    setTimeout( () => this.cdRef.detectChanges() ) 
  		});

		// Request a GC session for encrypting credit details.
		// Promise.resolve( this.store.gcSession() ).then((key) => {
		// 	this.session = key;
		// });
	}


	unlinkForum() {
		try {
			this.user.unlinkForum().subscribe( (result) =>  {
				if ( result.status == 200 ) { this.authorize(); }
			});
		} catch (err) {
			console.log( err );
		};

	}

	linkForumAccount() {
		try {
			this.user.linkForum( this.profile.forum_account, this.profile.forum_password ).subscribe((user) =>  {
				if ( user.status == 200 ) {
					this.errorCode = 200;
					this.errorMsg = user.message;
					setTimeout( () => {
						this.showFixture = 'false';
						this.authorize();
					}, 1000);
				} else {
					this.errorCode = 400;
					this.errorMsg = user.message;
				}
			});
		} catch (err) {
			console.log( err );
		};
	}

	fetchUserInfo() {

		Promise.resolve(this.store.countPurchasedItems()).then( (theseProductsCount) => {
			this.itemscount = theseProductsCount;
		}).catch(function (err) { });

		Promise.resolve(this.store.getPurchasedProductsCount()).then( (usersClaimsCount) => {
			this.claimscount = usersClaimsCount;
		}).catch(function (err) { });

	}

	oAuthURLs() {
		this.authServices.forEach( (service, i) => {
			Promise.resolve( this.user.generateOAuthURL(service.name, true) ).then((data) => {
				this.authServices[i].link = data;
			});
		});
	}

	toggleOauth(service) {

		// Check account object if service exists, ex: 'user.facebook_id'
		if ( this.accounts[0][service.id] || this.accounts[0][service.id] != '' ) {

			Promise.resolve( this.user.removeOAuth(service.name) ).then((data) => {
				this.accounts[0][service.id] = false;
				this.authServices.forEach( (service) => {
					this.usingOAuth = (this.accounts[0][service.id]) ? true : false;
				});
				this.authorize();
			});

		} else {
			let oAuthtimer = setInterval( () => {
				this.user.addOAuth(service.name).subscribe((user) => {
					if (user) {
						this.authorize();
						this.accounts[0][service.id] = user[0][service.id];
						clearInterval(oAuthtimer);
					}
				});
			}, 2000);
		}
	}




	/**
	* 	Edit Account Page
	**/

	// Get account info for editing
	getAccount(user?) {
		let username = this.route.snapshot.params['id'] ? this.route.snapshot.params['id'] : user;
		Promise.resolve(this.user.getProfile( username )).then((identity) => {
			// Is this user viewing their own account
			if ( this.accounts && identity ) {
				if ( this.accounts[0].username == identity[0].username ) {
					this.ownprofile = true;
				}
				this.authServices.forEach( (service, i) => {
					if ( this.accounts[0][service.id] ) {
						this.usingOAuth = true;
					}
				});
			}
		});
	}

	clearEdits() {
		this.editing = [];
		this.profile = this.oringinalprofile;
	}

	edit(item) {
		this.clearEdits();
		this.profile = this.accounts[0];
		this.profile.username = '';
		this.oringinalprofile = this.accounts[0];
		this.editing[item] = this.editing[item] ? false : true
	}

	updateAccount() {

		this.savingAccount = true;
		this.usererr = null;
		Promise.resolve( this.user.updateAccount(this.profile) ).then((account) => {

			this.savingAccount = false;
			this.usererr = account[0].error;
			this.title = account[0].username;
			this.birthdate = account[0].birthdate;
			this.bg = account[0].background;
			this.accounts = account;
			this.profile.username = '';
			this.profile.profile = account[0].profile;

			// $('html, body').animate({ scrollTop: 0 }, 800);

			this.clearEdits();
		});
		setTimeout (() => { this.usererr = null; }, 10000);
	}


	editTagline() {
		this.profile = this.accounts[0];
		this.updatingTagline = true;

	}

	updateTagline() {
		Promise.resolve( this.user.updateAccount(this.profile) ).then((account) => {
			this.updatingTagline = false;
			if ( account[0] ) {
				this.subtitle = account[0].tagline;
			}
		});
	}

	getCurrencies() {
		Promise.resolve(this.store.getCurrencies()).then((c) => {
			this.currencies = c;
			this.defaultCurrency = c[0];
			Promise.resolve(this.store.getCurrency()).then((c) => {
				this.currency = c[0];
			});
		});
	}

	getCountries() {
		Promise.resolve( this.user.getCountryCodes() ).then((countries) => {
			this.countries = countries;
		});
	}

	uplodProfileImage() {
		this.fileInput.nativeElement.click()
	}

	previewBackground(item) {
		this.bgpreview = this.sanitizer.bypassSecurityTrustStyle( 'url("'+item.url+'")' );
	}

	saveBackground(item) {
		this.bg = item.url;
		this.profile.background = item.url;
		this.editingBackground = false;
		Promise.resolve( this.user.updateAccount(this.profile) ).then( (account) => {
			if ( account[0] )
				this.bg = account[0].background;
			this.bgpreview = false;
		});
	}

	resetBackground() {
		this.bgpreview = false;
	}


	alignBackground(event) {
		this.bgY = event.clientY/this.height*100;
	}


	newAddress() {
		// this.store.getNewCryptoAddress( this.selectedCoin ).subscribe( (addr) => {
		// 	this.cryptoAddress = addr;
		// });
	}



	testDualFactor(key) {
		this.user.dualFactor(key).subscribe( (result) => {
			this.dualFactorStatus = result;
		});
	}


	setupDualFactor() {
		this.user.setupDualFactor().subscribe( (key) => {
			this.dualFactorKey = key.secret;
			this.dualFactorQR = key.qr;
			this.overlay('dualfactor');
		});
	}


	invite() {
		Promise.resolve( this.user.inviteToSocialNetwork(this.social.email) ).then( ( result ) => {
			this.accounts = result;
		});
	}

	getMessages() {
		Promise.resolve( this.soc.getOpenConversations() ).then( ( msg ) => {
			this.messages = msg;
		});
	}

	getNotifications() {
		Promise.resolve( this.soc.getNotifications() ).then( ( notif ) => {
			this.notification = notif;
		});
	}




	/* On with the show */
	ngOnInit() {

		this.getAccount(this.route.snapshot.params['id']);
		this.getPaymentProducts();
		this.getNotifications();
		this.getBackgorunds();
		this.cachedMachines();
		this.getCurrencies();
		this.fetchUserInfo();
		this.getCountries();
		this.getMessages();
		this.newAddress();
		this.oAuthURLs();
		this.authorize();

		if ( this.route.snapshot.params['path'] && this.route.snapshot.params['path'] != 'view' )  {
			this.view = this.route.snapshot.params['path'];
		} else if ( this.products && this.products[0] != null ) {
			this.view = 'edit';
		}

		this.coinAddress = '123';
		this.height = 400;
		this.headerHeight = this.height+'px';
		this.subtitle = '';

		this.viewMode = this.cookie.get('view') ? this.cookie.get('view') : 'list';
		this.changeViewMode(this.viewMode);

	}

	ngAfterViewInit() {
		// $('.hidden-upload-box').click(function (e) {
		// 	console.log(e);
		// });
	}

}

// Export the constructor Login form
export class Profile {

	constructor(
		public username?: string,
		public firstname?: string,
		public surname?: string,
		public profile?: string,
		public profile_raw?: string,
		public email?: string,
		public tagline?: string,
		public background?: string,
		public password?: string,
		public birthday?: string,
		public sex?: string,
		public street?: string,
		public forum_account?: string,
		public forum_password?: string,
		public housenumber?: string,
		public zip?: string,
		public city?: string,
		public state?: string,
		public steam_id?: string,
		public facebook_id?: string,
		public live_id?: string,
		public has_live?: boolean,
		public has_steam?: boolean,
		public has_facebook?: boolean,
		public countrycode?: string
	) {}

}

// Help parse Location Hashtags
export class HashLocationComponent {
  location: Location;
  constructor(location: Location) { this.location = location; }
}

// This constructor generates the Login form
export class CreditCard {

  constructor(
	private cardholderName: string,
	private cardNumber: number,
	private cvv: number,
	private expiryDate: string,
	private paymentProductId: any,
	public terms: boolean
  ) {}

}

export class Gift {

	constructor(
		public username?: string,
		public release?: boolean
	) {}

}

export class Amount {
	constructor(
		public amount?: number
	) {}
}

export class Crypto {
	constructor(
		public crypto?: any
	) {}
}

export class PaymentDetails {
  constructor(
	public totalAmount?: number,
	public currency?: string,
	public countryCode?: string,
	public isRecurring?: boolean,
	public locale?: string
  ) {}
}

export class Social {
	constructor(
		public email?: any
	) {}
}

export class Search {
	constructor(
		public term?: any
	) {}
}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/user.component.ts